import {
  GIF_EDIT_MAX_FRAMES,
  GIF_EDIT_MAX_FULL_PIXEL_FRAMES,
  GIF_EDIT_MAX_LOGICAL_PIXELS,
  GIF_EDIT_MAX_PATCH_PIXELS,
  GIF_EDIT_MAX_SIDE,
  GIF_EDIT_MAX_SOURCE_BYTES,
  GifEditAdmissionError,
  toSafeIntegerProduct,
} from './limits'
import type { GifEditMetadata } from './parseGif'
import { assertGifEditRecipe } from './recipe'
import type { GifEditRecipe } from './recipe'
import { getGifEditOutputGeometry } from './transform'

export const admitGifEdit = (
  sourceBytes: number,
  metadata: GifEditMetadata,
  recipe: GifEditRecipe,
): void => {
  assertGifEditRecipe(recipe)

  if (sourceBytes > GIF_EDIT_MAX_SOURCE_BYTES) {
    throw new GifEditAdmissionError('sourceBytes')
  }

  if (
    metadata.width > GIF_EDIT_MAX_SIDE ||
    metadata.height > GIF_EDIT_MAX_SIDE
  ) {
    throw new GifEditAdmissionError('dimension')
  }

  const logicalPixels = toSafeIntegerProduct(metadata.width, metadata.height)
  if (logicalPixels === null || logicalPixels > GIF_EDIT_MAX_LOGICAL_PIXELS) {
    throw new GifEditAdmissionError('logicalPixels')
  }

  if (metadata.frameCount > GIF_EDIT_MAX_FRAMES) {
    throw new GifEditAdmissionError('frameCount')
  }

  if (metadata.patchPixels > GIF_EDIT_MAX_PATCH_PIXELS) {
    throw new GifEditAdmissionError('patchPixels')
  }

  const output = getGifEditOutputGeometry(
    { width: metadata.width, height: metadata.height },
    recipe,
  )
  if (output.width > GIF_EDIT_MAX_SIDE || output.height > GIF_EDIT_MAX_SIDE) {
    throw new GifEditAdmissionError('dimension')
  }

  const outputPixels = toSafeIntegerProduct(output.width, output.height)
  if (outputPixels === null || outputPixels > GIF_EDIT_MAX_LOGICAL_PIXELS) {
    throw new GifEditAdmissionError('logicalPixels')
  }

  const fullPixelFrames = toSafeIntegerProduct(
    metadata.frameCount,
    Math.max(logicalPixels, outputPixels),
  )
  if (
    fullPixelFrames === null ||
    fullPixelFrames > GIF_EDIT_MAX_FULL_PIXEL_FRAMES
  ) {
    throw new GifEditAdmissionError('fullPixelFrames')
  }
}
